import React from "react";
import { FormattedMessage } from "react-intl";

// Minimal sidebar for the two Shipshopy external users (see
// ../BulkAnalysis/deliveryCenterExternalAccess.js) — a single item pointing at Delivery Center
// Orders, nothing else. Wired in ../../index.js as a short-circuit before the normal role-based
// menu assembly, so it applies regardless of these two accounts' stored role/userType.
export const DeliveryCenterOnlyMenu = {
  id: "DeliveryCenterOnly",
  title: <FormattedMessage id="Bulk" />,
  type: "group",
  children: [
    {
      id: "Delivery Center Orders",
      title: <FormattedMessage id="Delivery Center Orders" />,
      type: "item",
      url: "/bulk/delivery-center-orders",
    },
  ],
};
